import axios from 'axios';
axios.defaults.baseURL =  window.location.protocol + '//' + window.location.host + '/' ;
axios.defaults.headers['select-version'] = '2.5.0.56'
